export default __webpack_public_path__ + "static/barren-b5c4b1657918e15631cc3a709b12d7a5.jpg";